import { useTranslation } from "react-i18next";

export const Chip = ({ active, onClick, children, testId, readOnly, className }) => (
  <button
    type="button"
    data-testid={testId}
    onClick={readOnly ? undefined : onClick}
    aria-disabled={readOnly || undefined}
    className={`whitespace-nowrap rounded-2xl bg-background px-2 py-2 text-xs font-bold transition-[box-shadow,color] duration-300 ${
      active ? "text-primary shadow-neu-in" : "shadow-neu-sm text-muted-foreground hover:text-foreground"
    } ${readOnly ? "cursor-default" : ""} ${className || ""}`}
  >
    {children}
  </button>
);

export const YesNo = ({ label, value, onChange, testId }) => {
  const { t } = useTranslation();
  return (
    <div>
      <p className="label-xs mb-2">{label}</p>
      <div className="flex gap-2">
        <Chip active={value === true} onClick={() => onChange(true)} testId={`${testId}-yes`}>
          {t("app.yes")}
        </Chip>
        <Chip active={value === false} onClick={() => onChange(false)} testId={`${testId}-no`}>
          {t("app.no")}
        </Chip>
      </div>
    </div>
  );
};
